module.exports = require("@hs/types");